<template>
  <transition name="pop" appear>
    <div
      :class="{ 'is-showing': modalShow }"
      class="app-modal"
      @click="CloseModal()"
      @keyup.esc="CloseModal()"
    >
      <div ref="appModal" class="app-modal--wrapper" @click.stop>
        <div class="app-modal__header">
          <div class="app-modal__header__title">{{ 'Activity Details' | t }}</div>
          <button ref="appModalClose" class="app-modal__header__close" @click="CloseModal()">
            <span class="material-icons-outlined">close</span>
          </button>
        </div>

        <div class="app-modal__subheader">
          <h5>{{ modalData.name }}</h5>
        </div>

        <div class="app-modal__body">
          <div class="app-modal__body__col">
            <div class="app-modal__body__col__item">
              <div class="label">{{ 'Description' | t }}</div>
              <p>{{ modalData.class_info.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    modalData: {
      type: Object,
      default: null
    },
    modalShow: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    modalShow() {
      if (this.modalShow && !this.isIosMobile) {
        document.body.style.overflow = 'hidden'
        this.$refs.appModalClose.focus()
      }
      if (this.isIosMobile) this.$refs.appModal.style.top = window.scrollY + 'px'
    }
  },
  methods: {
    CloseModal() {
      if (!this.isIosMobile) document.body.style.overflow = 'auto'
      this.$emit('close-modal')
    }
  }
}
</script>

<style lang="scss" scoped>
.app-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 2;
  max-height: 100vh;
  background-color: rgba($color-black, 0.6);
  overflow: auto;
  padding: 150px 0 40px;
  height: 0;
  width: 0;

  @include media-breakpoint-up(lg) {
    padding: 180px 0 40px;
  }

  &.is-showing {
    height: auto;
    width: 100%;
  }

  .ios-mobile & {
    position: absolute;
    display: block;
    max-height: 100%;
  }

  &--wrapper {
    position: relative;
    width: calc(100% - 30px);
    z-index: 3;
    background: $color-white;
    margin: 0 $container-paddings;

    @include media-breakpoint-up(lg) {
      width: $container;
    }
  }

  &__header {
    background: $color-gray-dark;
    padding: 8px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @include media-breakpoint-up(lg) {
      padding: 13px 15px 13px;
    }

    &__title {
      font-size: rem(18);
      line-height: rem(21);
      font-family: $font-secondary;
      color: $color-white;

      @include media-breakpoint-up(lg) {
        font-size: rem(20);
        line-height: rem(24);
      }
    }

    &__close {
      border: 0;
      box-shadow: none;
      background: transparent;
      color: $color-white;
      padding: 0;
      cursor: pointer;

      &:focus {
        outline: none;
      }

      span {
        display: block;
      }
    }
  }

  &__subheader {
    padding: 16px 15px 17px;

    @include media-breakpoint-up(lg) {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    h5 {
      margin-bottom: 15px;

      @include media-breakpoint-up(lg) {
        margin-bottom: 0;
      }
    }
  }

  &__body {
    font-size: rem(14);
    line-height: rem(19);

    @include media-breakpoint-up(lg) {
      display: flex;
    }

    &__col {
      padding: 20px 15px 17px;
      flex: 1;

      @include media-breakpoint-up(lg) {
        padding: 16px 15px 30px;
      }

      &:first-child {
        background: $color-gray-light;
      }

      &:last-child {
        background: $color-gray-bg;
      }

      &__item {
        margin-top: 15px;

        &:first-child {
          margin-top: 0;
        }

        .label {
          font-weight: bold;
          margin-bottom: 10px;
        }

        p {
          margin-bottom: 5px;
        }
      }
    }
  }
}

.app-modal__subheader {
  padding: 28px 15px;

  h5 {
    margin-bottom: 0;
  }
}

.pop-enter-active,
.pop-leave-active {
  transition: opacity 0.2s ease-in-out;
}

.pop-enter,
.pop-leave-to {
  opacity: 0;
}
</style>
